import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { QRCodeComponent } from 'angularx-qrcode';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { environment } from '../../../../../../environments/environment';
import { RegisterMemberResponse } from '../../../../../core/models/member.model';
import {
  PaymentTopupMemberPayload,
  PaymentTopupParkingPayload,
  PaymentTopupParkingResponse,
} from '../../../../../core/models/payment.model';
import { PssLoadingComponent } from '../../../../../tools/template/pss/pss-loading/pss-loading.component';
import { ParkingUserVehicleDto } from '../../../../../core/models/ev.model';
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { CityParkingAccountTopUp } from '../../../../../core/models/topUpAccount.model';
import { ApiHandlerService } from '../../../../../tools/services/api/handler-api/apiHandler.service';
import { ApiTopUpService } from '../../../../../core/services/api/Topup/api-topup';
import { ApiMemberService } from '../../../../../core/services/api/Member/api-member';

@Component({
  selector: 'app-payment-services',
  imports: [CommonModule, FormsModule, PssLoadingComponent],
  templateUrl: './payment-services.component.html',
  styleUrl: './payment-services.component.css',
})
export class PaymentServicesComponent implements OnInit {
  currentLang: 'TH' | 'EN' = 'TH';
  sub!: Subscription;
  token: string = '';
  uid: string = '';
  isLoading: boolean = false;
  obfuscatedCode: string = '';
  isOpenModalChose: boolean = false;
  isOpenModalQr: boolean = false;
  isOpenModalTopup: boolean = false;
  selectedId: string = '';
  paymentMember: RegisterMemberResponse[] = [];
  filteredPaymentMember: RegisterMemberResponse[] | null = null;

  /* --- Search  ----*/
  searchText: string = '';

  /* --- Modal Payment ---*/
  selectedTransaction: RegisterMemberResponse | null = null;
  dateNow: Date = new Date();
  topupAmount: CityParkingAccountTopUp = {
    amount: 0,
    accountName: '',
    accountNumber: '',
    userId: 0,
    status: 0
  };


  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false;
  textWarn: string = '';
  detailWarn: string = '';
  isError: boolean = false;
  textError: string = '';
  detailError: string = '';

  constructor(
    private router: Router,
    private languageService: LanguageService,
    private cookieService: CookieService,
    private apiTopUpService: ApiTopUpService,
    private apiMemberService: ApiMemberService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private apiHandler: ApiHandlerService,
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';

    this.getRegisterMemberPayment();
  }

  get totalPendingCount(): number {
    if (!this.paymentMember) return 0;
    return this.paymentMember.filter(item => item.total > 0).length;
  }

  get totalPendingAmount(): number {
    if (!this.paymentMember) return 0;
    return this.paymentMember.reduce((acc, curr) => acc + (curr.total || 0), 0);
  }

  getCardGradient(index: number): string {
    const gradients = [
      'from-blue-400 to-sky-500',      // Blue
      'from-rose-400 to-pink-500',     // Pink/Red
      'from-purple-400 to-indigo-500', // Purple
      'from-amber-400 to-orange-500',  // Orange
      'from-emerald-400 to-teal-500',  // Green
    ];
    return gradients[index % gradients.length];
  }

  /* ----------------------------------------- Function ---------------------------------------*/
  /* --- Defualt ---*/
  goback() {
    this.router.navigate(['/home']);
  }
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text)
  }

  /* --- Search ---*/
  onSearch() {
    if (this.searchText === '') {
      this.filteredPaymentMember = null;
    }

    this.filteredPaymentMember = this.paymentMember.filter((item) => {
      return item.plate_number
        .toLowerCase()
        .includes(this.searchText.toLowerCase());
    });
    console.log('search', this.searchText);
  }
  onClearSearch() {
    this.searchText = '';
    console.log('clear search', this.searchText);
  }

  /* --- Modal Payment ---*/
  closeModal() {
    this.selectedId = '';
    this.isOpenModalChose = false;
    this.isOpenModalQr = false;
    this.isOpenModalTopup = false;
  }
  navigateToQr(payment?: RegisterMemberResponse) {
    if (payment) {
      this.selectedTransaction = payment;
    }

    if (!this.selectedTransaction || this.selectedTransaction.total <= 0) {
      return;
    }

    // แปลงเลข cardCode เป็นตัวเลข
    const cardCodeNumber = this.selectedTransaction ? this.selectedTransaction.request_no : '0'
    console.log('cardCodeNumber : ', this.selectedTransaction.request_no);
    // แปลงฐาน 10 เป็นฐาน 16
    // const encoded = cardCodeNumber.toString(16); // เข้ารหัสเป็นฐาน 16
    console.log('encoded : ', cardCodeNumber, 'cardCodeNumber : ', cardCodeNumber);

    // ส่งข้อมูลไปยังหน้า QR Code
    const link = document.createElement('a');
    link.href = `${environment.webpayMemberUrl}${this.selectedTransaction.request_no}`;
    link.target = '_blank';
    link.click();
    this.isOpenModalChose = false;
  }
  navigateToQrParking(parking: RegisterMemberResponse) {
    this.selectedTransaction = parking;
    // แปลงเลข cardCode เป็นตัวเลข
    const cardCodeNumber = this.selectedTransaction ? this.selectedTransaction.request_no : '0'
    // แปลงฐาน 10 เป็นฐาน 16
    const encoded = cardCodeNumber //cardCodeNumber.toString(16); // เข้ารหัสเป็นฐาน 16
    console.log('encoded : ', encoded, 'cardCodeNumber : ', cardCodeNumber);

    // ส่งข้อมูลไปยังหน้า QR Code
    const link = document.createElement('a');
    link.href = `${environment.webpayMemberUrl}${this.selectedTransaction.request_no}`;
    link.target = '_blank';
    link.click();
    this.isOpenModalChose = false;
  }
  navigateToTopup() {
    if (this.selectedTransaction) {
      this.isOpenModalChose = false;
      this.getTopUpAccount();
    } else {
      console.log('No Selected');
    }
    // this.router.navigate(['/top-up'], {
    //   state: {
    //     cardCode: this.selectedId,
    //   },
    // });
  }

  paymentTopup() {
    // ตรวจสอบข้อมูลว่าการเลือก Transaction
    if (this.selectedTransaction) {
      // เช็คเงิน Top up ต้องมากกว่าค่าจอดรถ
      if (this.topupAmount.amount < this.selectedTransaction.total) {
        this.showWarning(
          this.currentLang === 'TH'
            ? 'จำนวนเงินที่เติมต้องมากกว่าค่าจอดรถ'
            : 'The top-up amount must be greater than the parking fee.'
        );
        return;
      }
      // เตรียมข้อมูล ส่ง API เติมเงิน
      const payload: PaymentTopupMemberPayload = {
        uid: this.uid,
        siteId: this.selectedTransaction.site_id,
        seq: this.selectedTransaction.request_no,
        parkingfee:
          this.selectedTransaction.fee,
        vat:
          this.selectedTransaction.vat,
        totalPay: this.selectedTransaction.total,
        topupAmount: this.topupAmount.amount,
        finance_id: this.selectedTransaction.finance_id,
        // subscriptId: this.selectedTransaction.subscriptId,
        //providerId: this.selectedTransaction.providerId,
      };

      console.log('payload top up : ', JSON.stringify(payload));
      // เรียกใช้ API เติมเงิน
      if (payload) {
        this.isLoading = true;
        this.sentPaymentTopupMember(payload);
      } else {
        console.log('No payload');
      }

    } else {
      console.log('No Selected');
      this.showWarning(
        this.currentLang === 'TH'
          ? 'ไม่พบข้อมูล กรุณาลองใหม่อีกครั้ง'
          : 'Data not found, please try again.'
      );
      this.isLoading = false;
    }
  }
  /* ------------------------------------------ API ------------------------------------------*/
  /* --- Payment Services ---*/
  getRegisterMemberPayment() {
    this.isLoading = true;
    this.apiHandler.handleApi(
      this.apiMemberService.getRegisterMemberPayment(this.uid, this.token),
      {
        logLabel: 'Get Register Member Payment',
        isConsoleLog: true,
        loading: (loading: boolean) => {
          return this.isLoading = loading;
        },
        success: (response: RegisterMemberResponse[]) => {
          console.log('response get register member payment : ', response);
          this.paymentMember = response;
          this.isLoading = false;
        },
        error: (error: any) => {
          this.isLoading = false;
        },
      }
    )
  }
  onClickPay(parking: RegisterMemberResponse) {
    this.isOpenModalChose = true;
    this.selectedTransaction = parking;
    console.log('selectedTransaction', this.selectedTransaction);
  }

  /* --- Modal Payment ---*/
  getTopUpAccount() {
    this.isLoading = true;
    this.apiTopUpService.getTopUpAccount(this.uid, this.token).subscribe({
      next: (response: CityParkingAccountTopUp) => {
        console.log('response top up modal  : Amount Top Up : ', response);
        this.isLoading = false;
        const now = new Date();
        this.dateNow = now;
        this.isOpenModalTopup = true;
        this.topupAmount = response;
      },
      error: (err) => {
        console.error('โหลดข้อมูล top up modal ล้มเหลว', err);
        this.isLoading = false;
      },
    });
  }
  sentPaymentTopupMember(payload: PaymentTopupMemberPayload) {
    this.apiTopUpService.sentApiPaymentTopupMember(payload, this.token).subscribe({
      next: (response: PaymentTopupParkingResponse) => {
        console.log('response top up payment : ', response);

        if (response.code === '000') {
          this.isLoading = false;
          this.showSuccess(
            this.currentLang === 'TH'
              ? response.message
              : response.message_en
          );
          this.isOpenModalTopup = false;
          this.isOpenModalChose = false;
          this.selectedTransaction = null;
        }
        else {
          this.isLoading = false;
          this.showError(
            this.currentLang === 'TH'
              ? response.message
              : response.message_en
          );
        }
      },
      error: (err) => {
        console.error('ส่งข้อมูล top up payment ล้มเหลว', err);
        this.isLoading = false;
        this.showError(
          this.currentLang === 'TH'
            ? 'ส่งข้อมูลล้มเหลว กรุณาลองใหม่อีกครั้ง'
            : 'Data submission failed, please try again.'
        );
      }
    });
  }
}

